module.exports = __webpack_public_path__ + "img/5.72e3f574.png";